var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04025 5.3998C9.33022 5.11028 9.80993 5.11017 10.0998 5.3998C10.3898 5.6898 10.3898 6.17035 10.0998 6.46035L5.30979 11.2504H20.5002C20.9101 11.2506 21.2502 11.5905 21.2502 12.0004C21.2501 12.4101 20.91 12.7502 20.5002 12.7504H5.30979L10.0998 17.5404C10.3897 17.8304 10.3897 18.31 10.0998 18.6C9.95982 18.75 9.75955 18.8207 9.56955 18.8207C9.37969 18.8206 9.19016 18.7499 9.04025 18.6L2.96994 12.5307C2.67994 12.2407 2.67994 11.7601 2.96994 11.4701L9.04025 5.3998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.c962447fec3ded1dba68bbfc868b78de.svg";
export { ForwardRef as ReactComponent };